/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Role,
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';

/**
 * 
 * @export
 * @interface SimpleViewAcademicUserDTO
 */
export interface SimpleViewAcademicUserDTO {
    /**
     * 
     * @type {string}
     * @memberof SimpleViewAcademicUserDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleViewAcademicUserDTO
     */
    readonly name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleViewAcademicUserDTO
     */
    readonly cursId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimpleViewAcademicUserDTO
     */
    readonly email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleViewAcademicUserDTO
     */
    readonly phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimpleViewAcademicUserDTO
     */
    readonly image?: string | null;
    /**
     * 
     * @type {Array<Role>}
     * @memberof SimpleViewAcademicUserDTO
     */
    readonly roles?: Array<Role> | null;
}

export function SimpleViewAcademicUserDTOFromJSON(json: any): SimpleViewAcademicUserDTO {
    return SimpleViewAcademicUserDTOFromJSONTyped(json, false);
}

export function SimpleViewAcademicUserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleViewAcademicUserDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'cursId': !exists(json, 'cursId') ? undefined : json['cursId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'roles': !exists(json, 'roles') ? undefined : (json['roles'] === null ? null : (json['roles'] as Array<any>).map(RoleFromJSON)),
    };
}

export function SimpleViewAcademicUserDTOToJSON(value?: SimpleViewAcademicUserDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

